import React, { Component } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Services from '../../services/service';

class ModalAddForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      building: '',
      floor: '',
      name: '',
      instanceNumber: '',
      buildingList: [],
      floorList: [],
    };
    this.initialState = this.state;
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.getBuildingList();
    this.getFloorList();
  }

  getBuildingList = () => {
    Services.getList({ param: 'building-category' })
      .then(res => {
        this.setState({ buildingList: res });
      })
      .catch(err => console.log(err))
  };

  getFloorList = () => {
    Services.getList({ param: 'building-floor' })
      .then(res => {
        this.setState({ floorList: res });
      })
      .catch(err => console.log(err))
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit = () => {
    const { name, instanceNumber, building, floor } = this.state;
    const payload = { name, instanceNumber, building, floor };
    Services.postBasControl(payload).then(res => {
      this.props.addNotification('success', 'Success', res.msg, 'top-right');
      this.props.getDataBasControl();
      this.props.toggle();
    }).catch(err => {
      console.log(err);
      const message = err?.response?.data?.error;
      this.props.addNotification('danger', 'Failed', message ?? 'Oops something went wrong !', 'top-right');
    })
  }

  render() {
    const { isOpen, toggle } = this.props;
    const { name, instanceNumber, building, floor, buildingList, floorList } = this.state;
    const disabled = [name, instanceNumber, building, floor].some(item => item === '');

    return (
      <Modal isOpen={isOpen}>
        <ModalHeader toggle={() => toggle()}>Tambah BAS Control</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Nama</label>
            <input
              name='name'
              className="form-control"
              type="text"
              value={name}
              onChange={this.handleChange}
            />
          </div>
          <div className="form-group">
            <label>Instance Number</label>
            <input
              name='instanceNumber'
              className="form-control"
              type="text"
              value={instanceNumber}
              onChange={this.handleChange}
            />
          </div>
          <div className="form-group">
            <label>Building</label>
            <select
              name='building'
              className="form-control"
              value={building}
              onChange={this.handleChange}
            >
              <option disabled value=''> - pilih - </option>
              {buildingList.map((item) => (
                <option key={item.id} value={item.id}>{item.name}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Floor</label>
            <select
              name='floor'
              className="form-control"
              value={floor}
              onChange={this.handleChange}
            >
              <option disabled value=''> - pilih - </option>
              {floorList.map((item) => (
                <option key={item.id} value={item.id}>{item.name}</option>
              ))}
            </select>
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-white" onClick={() => toggle()}>Cancel</button>
          <button
            className="btn btn-primary"
            disabled={disabled}
            onClick={this.handleSubmit}
          >
            Create
          </button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ModalAddForm;
